<template>
  <div class="wrapper">
    <the-nav-bar :title="$t('payInfo.select')">
      <span slot="left" class="spacer"></span>
    </the-nav-bar>
    <div class="body-wrapper">
      <md-radio-list v-model="current" :options="options">
        <template slot-scope="{ option, selected }">
          <md-field :class="{ selected: selected }">
            <div class="field-header-title row-align-center" slot="header">
              <img
                class="pay-icon"
                :src="getPayIcon(option.method)"
                :alt="getPayName(option.method)"
              />
              <span class="pay-name">{{ getPayName(option.method) }}</span>
            </div>
            <div class="field-header-action" slot="action">
              <md-icon
                name="right"
                v-if="selected"
                size="lg"
                color="#1b6fdc"
              ></md-icon>
              <md-icon name="check" v-else size="lg"></md-icon>
            </div>
            <md-detail-item
              :title="$t('payInfo.trueName')"
              :content="option.trueName"
            ></md-detail-item>
            <md-detail-item
              v-if="'alipay' === option.method"
              :title="$t('payInfo.alipayAccount')"
              :content="option.account"
            ></md-detail-item>
            <md-detail-item
              v-if="'wechatpay' === option.method"
              :title="$t('payInfo.wechatAccount')"
              :content="option.account"
            ></md-detail-item>
            <md-detail-item
              v-if="'bank' === option.method"
              :title="$t('payInfo.bankAccount')"
              :content="option.account"
            ></md-detail-item>
            <md-detail-item
              v-if="'bank' === option.method"
              :title="$t('payInfo.bankName')"
              :content="`${option.address1} ${option.address2}`"
            ></md-detail-item>
          </md-field>
        </template>
      </md-radio-list>
    </div>
    <div class="footer-wrapper" v-show="showBtn">
      <md-button
        :type="current && !isSending ? 'primary' : 'disabled'"
        @click="onSend"
      >
        <md-activity-indicator
          v-if="isSending"
          type="carousel"
          color="currentColor"
        />
        <span v-else>{{ $t('payInfo.send') }}</span>
      </md-button>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Toast,
  Button,
  RadioList,
  Field,
  DetailItem,
  ActivityIndicator,
  Icon,
  Dialog,
} from 'mand-mobile';
import getPayIcon from '@/utils/get-payment-icon.js';
import { sendPayInfo, getOrderPayInfo } from '@/api/user';
export default {
  components: {
    TheNavBar,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [RadioList.name]: RadioList,
    [Field.name]: Field,
    [DetailItem.name]: DetailItem,
    [Button.name]: Button,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      current: '',
      showBtn: true,
      isSending: false,
      options: [],
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  mounted() {
    if (!this.id) {
      Toast.failed(this.$t('error.para'));
      return;
    }
    getOrderPayInfo(this.id)
      .then(data => {
        const d = data.data;
        if (Array.isArray(d) && d.length) {
          d.forEach(item => {
            this.options.push({
              value: item.id,
              method: item.symbol,
              trueName: item.content.truename,
              account: item.content.account,
              address1: item.content.name || '',
              address2: item.content.address || '',
            });
          });
        }
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    getPayIcon(payment) {
      const map = {
        wechatpay: 'wechatpay',
        alipay: 'alipay',
        bank: 'unionpay',
      };
      return getPayIcon(map[payment]);
    },
    getPayName(payment) {
      const map = {
        wechatpay: 'wechatpay',
        alipay: 'alipay',
        bank: 'unionpay',
      };
      return this.$t(`payments.${map[payment]}`);
    },
    onSend() {
      this.isSending = true;
      sendPayInfo(this.id, this.current)
        .then(() => {
          this.isSending = false;
          this.showBtn = false;
          Dialog.alert({
            icon: 'success-color',
            title: this.$t('payInfo.sendSuccess'),
            confirmText: this.$t('common.known'),
          });
        })
        .catch(err => {
          this.isSending = false;
          Dialog.alert({
            icon: 'fail',
            title: this.$t('error.occurs'),
            content: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.wrapper {
  background: #F8FBFC;
}

.body-wrapper {
  padding: 0 0 60vw;
  background: #F8FBFC;

  & >>> {
    .md-cell-item-body {
      padding: 0;
    }

    .md-cell-item-left {
      display: none;
    }
  }
}

.md-field {
  margin: 2.13vw 0 0;
  padding: 0;

  &.selected {
    box-shadow: 0vw 0 2.13vw 0vw rgba(58, 86, 131, 0.1);
  }

  & >>> {
    .md-field-header {
      position: relative;
      margin: 0;
      padding: 4.8vw;
      line-height: 6.4vw;
      hairline(bottom, #eaf1f3);
    }

    .md-field-content {
      padding: 2.13vw 4.8vw 4.8vw;
    }

    .md-detail-title {
      font-size: 3.2vw;
      color: #2c3133;
    }

    .md-detail-content {
      font-size: 3.2vw;
      font-weight: 600;
      color: #84969c;
    }
  }

  .field-header-title {
    .pay-icon {
      width: 6.4vw;
      height: 6.4vw;
    }

    .pay-name {
      margin-left: 2.13vw;
      font-size: 3.73vw;
      font-weight: bold;
    }
  }
}

.footer-wrapper {
  position: fixed;
  left: 4.8vw;
  right: 4.8vw;
  bottom: 0;
  bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
  z-index: 100;

  .md-button {
    margin-bottom: 4.8vw;
  }

  & >>> .md-activity-indicator-svg {
    width: 16vw !important;
    height: 4vw !important;
  }
}
</style>
